@if (!isHidden) {
    <div class="ca-checkbox-tile-slot-with-visual">
        @if (dataSourceState$ | async; as dataSourceState) {
            @if (dataSourceState.loading) {
                {{ 'LOADING.DATA_SOURCE' | delayDisplay | translate }}
            } @else {
                <div [caLayout]="slot().layout" (blur)="onTouched()" tabindex="0">
                    @for (item of dataSourceMapping || dataSourceState.dataSource.items; track item.value) {
                        <div class="relative" [formGroup]="formGroup">
                            <mat-checkbox
                                [disableRipple]="true"
                                class="ca-checkbox-tile-slot w-full"
                                [formControlName]="$any(item.value)"
                                [checked]="isSelected(item.value)"
                                [disabled]="!!isDisabled"
                                (change)="onCheckboxChange($event, item.value)"
                            >
                                @if (isVisual) {
                                    <div class="ca-checkbox-visual-container">
                                        <ca-visual [slot]="slot()" [value]="item.value"></ca-visual>
                                    </div>
                                }
                                <div class="ca-checkbox-label-text flex items-center gap-2 pr-2">
                                    @let slotTitle = slot().titleKey | translationKey: slot().titleData : item.value;
                                    <span class="flex-grow">{{ slotTitle }}</span>
                                    @if (slot() | slotTooltip: item.value; as tooltip) {
                                        <ca-visual [tooltip]="tooltip"></ca-visual>
                                    }
                                </div>
                            </mat-checkbox>
                        </div>
                    }
                </div>
            }
        } @else {
            @let title = slot().titleKey | translationKey: slot().titleData;
            <div class="relative" [formGroup]="formGroup">
                <mat-checkbox
                    class="ca-checkbox-tile-slot"
                    [attr.aria-label]="title"
                    [formControl]="control"
                    [checked]="value()"
                    [disableRipple]="true"
                    [disabled]="!!isDisabled"
                    (change)="onValueChange($event.checked)"
                    (blur)="onTouched()"
                >
                    @if (isVisual) {
                        <div class="ca-checkbox-visual-container">
                            <ca-visual [slot]="slot()" [iconSize]="24"></ca-visual>
                        </div>
                    }

                    <div class="ca-checkbox-label-text flex items-center gap-2 pr-2">
                        @if (title) {
                            <span class="flex-grow">{{ title }}</span>
                        }
                        @if (slot() | slotTooltip; as tooltip) {
                            <ca-visual [tooltip]="tooltip"></ca-visual>
                        }
                    </div>
                </mat-checkbox>
            </div>
        }

        @if (isErrorMessage) {
            <div class="ca-subscript relative">
                <div class="absolute ca-error-message" @slideDown>
                    <ca-form-error-message>
                        {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                    </ca-form-error-message>
                </div>
            </div>
        }
    </div>
}
